/**
 * CategoryFilters Component
 *
 * Wrapper around GenericFilters with category-specific configuration.
 * Reduced from 228 lines to 19 lines (92% reduction).
 */

import React from 'react';
import { GenericFilters } from '../ui/GenericFilters';
import { categoryFilterConfig } from './categoryFilterConfig';
import type { CategoryFilters as CategoryFilterType } from '../../types/category';

interface CategoryFiltersProps {
  filters: CategoryFilterType;
  onFiltersChange: (filters: CategoryFilterType) => void;
}

export function CategoryFilters({ filters, onFiltersChange }: CategoryFiltersProps) {
  return (
    <GenericFilters
      filters={filters}
      onFiltersChange={onFiltersChange}
      config={categoryFilterConfig}
    />
  );
}
